import React from 'react';
import { CheckCircle2, AlertTriangle, ExternalLink } from 'lucide-react';
import { StatusBadge as SharedStatusBadge } from '../StatusBadge';

export const inr = value => `₹${Number(value || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const LineStatus = ({ line, index }) => {
  if (!line) return <span className="text-[11px] text-gray-500">–</span>;
  if (!line.errors?.length) {
    return (
      <div className="text-[11px] text-green-700" data-testid={`purchase-line-status-${index}`}>
        <CheckCircle2 className="mr-1 inline h-3.5 w-3.5" />OK
        <div className="text-gray-500">Stock {line.current_stock} → {line.new_stock}{line.stock_sku !== line.sku_code ? ` (${line.stock_sku})` : ''}</div>
        <div className="text-gray-500">Cost {inr(line.current_cost)} → {inr(line.new_cost)}</div>
        {line.warnings?.map(w => <div key={w} className="text-amber-700">{w}</div>)}
      </div>
    );
  }
  return (
    <div className="text-[11px] text-red-700" data-testid={`purchase-line-status-${index}`}>
      <AlertTriangle className="mr-1 inline h-3.5 w-3.5" />{line.errors.join('; ')}
      {line.missing_sku && (
        <a href={`/skus?create=${encodeURIComponent(line.sku_code)}`} target="_blank" rel="noreferrer"
          className="mt-0.5 flex items-center gap-1 font-medium text-blue-700 hover:underline" data-testid={`purchase-create-sku-${index}`}>
          <ExternalLink className="h-3 w-3" />Create SKU {line.sku_code}
        </a>
      )}
    </div>
  );
};

// Purchase status pill, rendered with the app-wide StatusBadge so DRAFT/POSTED/REVERSED look the same everywhere.
export const StatusBadge = ({ status }) => <SharedStatusBadge status={status} data-testid={`purchase-status-${status}`} />;
